import OptimizedImage from "@/components/OptimizedImage";
import React from "react";
import { useArtistStory } from "@/api/hooks/useArtistStory";
import { useArtistDisplayName, useArtistProfilePic } from "@/api/hooks/useArtistDisplayName";
import { ArtistStoryRichText } from "@/components/profile/ArtistStoryRichText";
import { WEBSITE_STORY_HOVER_TEXT } from "@/pages/profile/website-preview/storyPreviewHoverClasses";
import { cn } from "@/utils/cn";
import { User } from "lucide-react";

const ArtistEliteStory = () => {
  const { storyHtml, hasStory } = useArtistStory();
  const displayName = useArtistDisplayName();
  const profilePic = useArtistProfilePic();

  return (
    <div>
      <div className="flex justify-center items-center max-md:text-center flex-col mt-40 w-screen">
        <h2 className="text-[42px] font-bold bg-gradient-to-r from-[#F16B2E] via-[#EC2179] to-[#EC2179] text-transparent bg-clip-text w-fit ">
          My Story
        </h2>

      </div>
      <div className="flex items-start max-sm:flex-col justify-evenly gap-10 mt-5 mb-40 px-4 w-screen">
        <div className="rounded-3xl relative w-[500px] max-sm:w-full h-[75vh] min-h-[600px] overflow-hidden bg-[#2C2C2E] flex items-center justify-center">
          {profilePic ? (
            <OptimizedImage
              src={profilePic}
              fill
              unoptimized
              alt={displayName}
              className="object-cover object-top rounded-3xl"
            />
          ) : (
            <User className="h-[40%] w-[40%] text-[#8E8E93] opacity-50" />
          )}
        </div>

        <div className="max-w-xl space-y-4">

          <div className="group max-w-full">
            <ArtistStoryRichText
              storyHtml={storyHtml}
              hasStory={hasStory}
              variant="split"
              className={cn('text-lg max-sm:text-sm opacity-80', WEBSITE_STORY_HOVER_TEXT)}
            />
          </div>

          {/* <p className="text-lg max-sm:text-sm opacity-80">
  Arjun is a 21-year-old musician based in Delhi, driven by a deep passion for music. From a young age, he has been captivated by the art of sound and performance, and he is now channeling that passion into building a serious career. Known for his soulful voice and musical sensitivity, he has gained recognition for his covers of popular English songs, which have received encouraging responses online. His consistent growth and strong presence mark him as a promising talent in the contemporary music scene.
  <br />
  <br />
  Arjun began exploring music in his early teens and quickly developed a keen ear for melody and rhythm. His journey as an artist has been defined by persistence, experimentation, and a commitment to evolving his craft. With every performance, Arjun demonstrates a rare combination of raw potential and refined execution. As he continues to produce content and engage with listeners, he is steadily carving his path toward success. With talent and tenacity, Arjun stands out as one of Delhi’s most promising emerging musicians.
</p> */}

          <button className="bg-gradient-to-b from-[#EC2179] to-[#F16B2E] px-8 py-3 text-lg max-sm:text-sm rounded-xl">
            SEE PRICE & BOOK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArtistEliteStory;
